// extracted by mini-css-extract-plugin
export var image = "j1_dp";